export default function initTabs() {
    const tabComponents = document.querySelectorAll('.mod-tabs-content');
    if (!tabComponents.length) return;

    tabComponents.forEach(component => {
        const tabs = Array.from(component.querySelectorAll('[role="tab"]'));
        const panels = Array.from(component.querySelectorAll('[role="tabpanel"]'));

        let currentFocus = 0;

        // First ensure correct initialization since sometimes HTML is wrong
        const activeIndex = tabs.findIndex(tab => tab.classList.contains('active'));
        currentFocus = activeIndex > -1 ? activeIndex : 0;

        // Set up tabs and panels according to spec
        activateTab(currentFocus, false);

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                activateTab(index, true);
            });

            tab.addEventListener('keydown', (e) => {
                let newIndex = currentFocus;

                if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    newIndex = currentFocus + 1;
                    if (newIndex >= tabs.length) newIndex = 0;
                } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    newIndex = currentFocus - 1;
                    if (newIndex < 0) newIndex = tabs.length - 1;
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    newIndex = 0;
                } else if (e.key === 'End') {
                    e.preventDefault();
                    newIndex = tabs.length - 1;
                } else if (e.key === 'Tab' && !e.shiftKey) {
                    // Tab key moves focus into the active panel
                    // The browser will naturally move to the next focusable element, which could be the active panel itself if it has tabindex="0"
                    // So we don't necessarily need to preventDefault or do explicit focus, unless we want to force it to jump directly to the panel
                    // Since the panel has tabindex="0" and comes after the tablist in DOM, a regular tab will work nicely
                }

                if (newIndex !== currentFocus) {
                    activateTab(newIndex, true);
                    tabs[newIndex].focus();
                }
            });
        });

        function activateTab(index, focusTab = false) {
            currentFocus = index;

            tabs.forEach((t, i) => {
                const isSelected = i === index;
                t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                t.setAttribute('tabindex', isSelected ? '0' : '-1');
                if (isSelected) {
                    t.classList.add('active');
                } else {
                    t.classList.remove('active');
                }
            });

            panels.forEach((p, i) => {
                const isSelected = i === index;
                p.setAttribute('tabindex', isSelected ? '0' : '-1');
                if (isSelected) {
                    p.classList.add('active');
                } else {
                    p.classList.remove('active');
                }
            });
        }
    });
}
